const LoanAffidavit = () => {
  return (
    <div className="w-full p-6">
      <div className="space-y-6 text-gray-700 leading-relaxed">
        <h1 className="text-2xl font-bold text-gray-900">AFFIDAVIT</h1>
        <p className="uppercase font-semibold">
          IN THE MATTER OF THE OATHS AND STATUTORY DECLARATIONS ACT, CAP 15
        </p>
        <p className="uppercase font-semibold">AND</p>
        <p className="uppercase font-semibold">
          IN THE MATTER OF A LOAN FROM HELACRED
        </p>
        <p>
          I, <span className="font-semibold">[Full Name of Borrower]</span>, of
          National Identification Card Number{" "}
          <span className="font-semibold">[ID Number]</span>, a resident of{" "}
          <span className="font-semibold">[City/Town]</span> in the Republic of
          Kenya, and being an adult of sound mind and competent to swear this
          affidavit, do hereby solemnly swear and state as follows:
        </p>

        <ol className="list-decimal list-inside space-y-3">
          <li>THAT I am the above-named person, an adult of sound mind.</li>
          <li>
            THAT I am the borrower of a loan given by{" "}
            <strong>Helacred</strong>.
          </li>
          <li>
            THAT the facts deponed herein are within my personal knowledge,
            information, and belief, and are true and correct.
          </li>
          <li>
            THAT I took a loan from Helacred of KES{" "}
            <span className="font-semibold">[Amount]</span>.
          </li>
          <li>
            THAT I undertake to incur costs related to debt recovery and any
            administration.
          </li>
          <li>
            THAT I irrevocably assign all rights, title and interest in the
            assets contained in the Asset schedule and/or any other asset
            attachable in my premises and authorize Helacred and its
            agents, without requirement for any prior notice, to immediately
            upon default enter upon the land or premises where any assets I have
            pledged are located and take possession and dispose by way of Public
            Auction or any other method the group deems workable all properties
            seized.
          </li>
          <li>
            THAT what is deponed herein is true to the best of my knowledge,
            information, and belief.
          </li>
        </ol>

        <div className="mt-6 space-y-4">
          <p>SWORN by the said</p>
          <p>
            <strong>[Full Name of Borrower]</strong>
          </p>
          <p>
            <strong>Signature:</strong> __________________________
          </p>
          <p>
            SWORN at{" "}
            <span className="font-semibold">[City, e.g., Nairobi]</span> this{" "}
            <span className="font-semibold">[Day]</span> day of{" "}
            <span className="font-semibold">[Month], [Year]</span>
          </p>
          <p>
            <strong>BEFORE ME,</strong>
          </p>
          <p>COMMISSIONER FOR OATHS / MAGISTRATE</p>
          <p>
            <strong>Name:</strong> __________________________
          </p>
          <p>
            <strong>Signature &amp; Stamp:</strong> __________________________
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoanAffidavit;
